import React, { Component } from 'react';
import './text-menu.css';

export default class Menu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ul className="rdp-react-template-component-text-menu">
        <li className={`rdp-react-template-component-text-menu-item ${this.props.active === 0 ? "active" : ""}`} onClick={() => this.props.onChange(0)}>
          <span className="rdp-react-template-component-text-menu-item-icon info"></span>
          <span className="rdp-react-template-component-text-menu-item-label">Detalhes</span>
        </li>
        <li className={`rdp-react-template-component-text-menu-item ${this.props.active === 1 ? "active" : ""}`} onClick={() => this.props.onChange(1)}>
          <span className="rdp-react-template-component-text-menu-item-icon chat"></span>
          <span className="rdp-react-template-component-text-menu-item-label">Chat</span>
        </li>
        <li className={`rdp-react-template-component-text-menu-item ${this.props.active === 2 ? "active" : ""}`} onClick={() => this.props.onChange(2)}>
          <span className="rdp-react-template-component-text-menu-item-icon challenge"></span>
          <span className="rdp-react-template-component-text-menu-item-label">Desafios</span>
        </li>
      </ul>
    );
  }
}
